// Single source of truth for RSC / create-sales promo amounts.
//
// These amounts were being hardcoded independently in FOUR places — the RSC
// card (useRscEngine), the create-sales hand-off (residentialSolarCalculatorV2),
// the Advanced ROI searcher (RoiSearcherView) and the frozen-pricing snapshot
// (frozenPricing) — so every rate change had to be made in 4 spots and they
// drifted apart. Everything now imports from here so the RSC quotation and the
// created sale can never disagree again. (user 2026-08-07)
//
// Amounts set 2026-08-13 from the user's promo sheet. MECHANISM UNCHANGED —
// only the numbers moved:
//   Backupbox Removal   — 1P RM 1,600 · 3P RM 2,500   (not part of this change;
//                          only applies when the box is removed, i.e. no battery)
//   SuRIA Home Bonus    — box KEPT     RM 2,200 (both phases)
//                          box REMOVED  1P RM 1,200 · 3P RM 800
//                          NOTE: on the removed leg single-phase is deliberately
//                          HIGHER than three-phase, per the user's sheet.
//   Per-Battery (16kWh) — RM 1,200 per unit → GoodWe 16kWh nets 8,600 − 1,200 = RM 7,400
//
// NOT modelled: the "+RM500 labour when the battery is added after installation"
// on the user's sheet — the sale record has no post-install/retrofit flag, so
// agents add that manually for now.
//
// Existing sales are NOT swept — they keep the amounts frozen at creation
// (see feedback_no_backfill_rsc_promos). This only affects new quotes/sales.

export const backupboxRemoval = (is3p) => (is3p ? 2500 : 1600);

// boxRemoved = the backup box was taken out (no-battery option with the removal
// promo ticked). is3p = three-phase system.
export const suriaHomeBonus = (boxRemoved, is3p) =>
    boxRemoved ? (is3p ? 800 : 1200) : 2200;

export const PER_BATTERY_PROMO = 1200;                 // per 16kWh battery unit
export const perBatteryPromo  = (qty) => PER_BATTERY_PROMO * (Number(qty) || 0);
